<template>
  <ValidationObserver ref="observer" class="transition duration-500 ease-in-out transform w-full course-form"
                      style="transition: all 1s !important"
                      tag="form" @submit.prevent="submit()">
    <div class="w-full flex course-form__shell">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap course-form__grid">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Course Name</label>
            <validation-provider v-slot="{ errors }" :rules="{
              required: true,

            }">
              <input id="coursename" v-model="formValues.courseName" :disabled="formValues.isAccrediting" class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                  " name placeholder="coursename"
                     type="text"/>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Course Code<span style="font-weight: lighter">(To be filled by Accreditors)</span>)</label>

            <input id="courseCode" v-model="formValues.courseCode" :disabled="true" class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                  " name placeholder="Course Code"
                   type="text"/>

          </div>

          <div class="w-full px-3 mb-6 required course-levels">
            <div class="course-levels__header">
              <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Course Levels</label>
              <span class="course-levels__count">{{ courseLevels.length }} levels</span>
            </div>
            <div class="course-levels__editor">
              <div class="course-levels__table">
                <v-simple-table dense>
                  <thead>
                  <tr>
                    <th>Course Level</th>
                    <th>CEU</th>
                    <th>Duration (days)</th>
                    <th>Passing Score</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="course-levels__draft">
                    <td>
                      <v-select
                          v-model="courseLevelDraft.courseLevelId"
                          class="course-levels__input"
                          :clearable="clearable"
                          :elevation="1"
                          :items="COURSE_LEVELS"
                          :loading="courseLevelLoading"
                          :searchable="searchable"
                          dense
                          hide-details
                          item-text="name"
                          item-value="id"
                          placeholder="Course level"
                          solo
                      ></v-select>
                    </td>
                    <td>
                      <v-text-field
                          v-model="courseLevelDraft.continualEducationUnit"
                          class="course-levels__input"
                          dense
                          hide-details
                          placeholder="CEU"
                          type="number"
                          min="0"
                          max="15"
                          solo
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                          v-model="courseLevelDraft.courseDuration"
                          class="course-levels__input"
                          dense
                          hide-details
                          placeholder="Duration"
                          type="number"
                          min="1"
                          solo
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                          v-model="courseLevelDraft.passingScore"
                          class="course-levels__input"
                          dense
                          hide-details
                          placeholder="Passing score"
                          type="number"
                          min="0"
                          max="100"
                          solo
                      ></v-text-field>
                    </td>
                    <td class="course-levels__action">
                      <v-btn
                          class="course-levels__add"
                          color="primary"
                          small
                          @click="addCourseLevel"
                      >
                        <v-icon left small>mdi-plus-circle</v-icon>
                        Add Level
                      </v-btn>
                    </td>
                  </tr>
                  <tr v-for="(level, index) in courseLevels" :key="level.courseLevelId">
                    <td>{{ getCourseLevelName(level.courseLevelId, level.courseLevel) }}</td>
                    <td>{{ level.continualEducationUnit }}</td>
                    <td>{{ level.courseDuration }}</td>
                    <td>{{ level.passingScore }}</td>
                    <td class="course-levels__remove">
                      <v-btn icon @click="removeCourseLevel(index)">
                        <v-icon small>mdi-close</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr v-if="!courseLevels.length">
                    <td colspan="5" class="course-levels__empty">
                      No course levels added yet.
                    </td>
                  </tr>
                  </tbody>
                </v-simple-table>
              </div>
              <div v-if="courseLevelError" class="course-levels__error">
                {{ courseLevelError }}
              </div>
            </div>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Course Owner</label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete v-model="formValues.courseOwnerId" :clearable="clearable"
                              :disabled="(formValues?.courseOwnerId ?? false) || (formValues.isAccrediting)" :elevation="1"
                              :items="COURSE_OWNER" :loading="courseOwnerLoading" :searchable="searchable" dense
                              item-text="trainingCenterName"
                              item-value="id" label="course owners"
                              solo
              ></v-autocomplete>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Target Audience:
            </label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete v-model="formValues.targetAudienceIds" :clearable="clearable"
                              :disabled="formValues.isAccrediting" :items="TARGET_AUDIENCE"
                              :loading="targeAudLoading" :searchable="searchable" chips class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none
                    focus:shadow-outline
                  " deletable-chips
                              hint="select target audiences"
                              item-text="name" item-value="id" label="target audiences" multiple
                              persistent-hint>
              </v-autocomplete>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Cource Content</label>
            <validation-provider v-slot="{ errors }" :rules="{
              doc_file: true,
            }">
              <v-file-input
                  v-model="courseContentFile"
                  counter
                  label="Course content document"
                  name="courseContent"
                  show-size
                  accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  @change="handleCourseContentChange"
              ></v-file-input>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <div v-if="courseContentPreviewUrl || getCourseContentPath() || courseContentFile" class="course-content__preview">
              <div class="course-content__actions">
                <v-btn
                    class="course-content__action"
                    small
                    text
                    @click.prevent="openCourseContent"
                >
                  <v-icon left small>mdi-eye</v-icon>
                  Open
                </v-btn>
              </div>
              <iframe
                  v-if="hasInlineCourseContentPreview() && courseContentPreviewUrl"
                  class="course-content__frame"
                  :src="courseContentPreviewUrl"
                  title="Course content preview"
              ></iframe>
              <div v-else class="course-content__file">
                <v-icon color="primary">mdi-file-document-outline</v-icon>
                <div class="course-content__file-copy">
                  <div>{{ getCurrentCourseContentName() }}</div>
                  <div v-if="!courseContentPreviewUrl" class="course-content__file-note">
                    Preview unavailable here. Use Open to view the uploaded file.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!formValues.isAccrediting" class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Accredited By<span style="font-weight: lighter">(To be filled by Accreditors)</span>:
            </label>
            <v-select v-model="formValues.courseAccreditorId" :clearable="clearable"
                      :disabled="formValues?.courseAccreditorId ?? true"
                      :elevation="1" :items="ACCREDITED_BY" :loading="accreditorsLoading" :searchable="searchable" dense
                      item-text="accreditorName" item-value="id" solo></v-select>
            <br/>
          </div>

          <div v-else class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Accredited By<span style="font-weight: lighter">(To be filled by Accreditors)</span>:
            </label>
            <validation-provider v-slot="{ errors }" rules="required">

              <v-select v-model="formValues.courseAccreditorId" :clearable="clearable" :elevation="1"
                        :items="ACCREDITED_BY" :loading="accreditorsLoading" :searchable="searchable" dense
                        item-text="accreditorName"
                        :disabled="!canChooseAccreditor"
                        @change="updateAccreditorForCourseCode"
                        item-value="id" solo></v-select>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Date of Accreditation <span style="font-weight: lighter">(To be filled by Accreditors)</span>:
            </label>

            <v-menu ref="menu" v-model="startMenu" :close-on-content-click="false" max-width="290px"
                    min-width="290px"
                    offset-y transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="formValues.courseAccreditationDate" :disabled="true"
                              label="date of accreditation"
                              persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker
                  ref="courseAccreditationDate" v-model="formValues.courseAccreditationDate"
                  :max="date" no-title scrollable
                  @input="startMenu = false"
              ></v-date-picker>
            </v-menu>
            <span class="ml-6 ">( GC ) {{ convertEG(formValues.courseAccreditationDate) }}</span>

          </div>

        </div>

        <div class="flex flex-wrap course-form__actions">
          <div class="w-full">
            <button class="course-form__submit" type="button"
                    @click="showConfirmation(formValues.editMode, formValues.isAccrediting)"
            >
              {{
                formValues.editMode ? (formValues.isAccrediting ? "Accredit Course" : "Update Course") : "Add Course"
              }}
            </button>
          </div>
          <div class="md:w-2/3"></div>
        </div>

      </v-card>
      <confirmationModal
          v-if="confirmation"
          @confirmed="submit"
          :title="title"
          @close="confirmation = false"
          @openDialog="true"
      >
      </confirmationModal>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {regex, required} from "vee-validate/dist/rules";
import ethiopic from "ethiopic-calendar";
import {getCourseLevel, getHealthProfessions, getUser} from "@/utils/helper";
import {canAccreditCourses, canChooseCourseAccreditor} from "@/utils/courseAccess";
import {AccreditorService} from "../Accreditors/accreditor.service";
import {TrainingCenterService} from "../TrainingCenter/training_center.service";
import confirmationModal from "../../common/confirmation-modal.vue";
import {buildPreviewUrl, openPresignedUrl} from "@/utils/file";

extend("required", {
  ...required,
  message: "This field is required",
});
extend("regex", {
  ...regex,
  message: "Name should contain only letters",
});
const DOC_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
const DOC_EXTENSIONS = ["pdf", "doc", "docx"];
extend("doc_file", {
  message: "Only document files (PDF, DOC, DOCX) are allowed.",
  validate: (file) => {
    if (!file) return true;
    if (DOC_MIME_TYPES.includes(file.type)) return true;
    const ext = file.name?.split(".").pop()?.toLowerCase();
    return DOC_EXTENSIONS.includes(ext);
  },
});
export default {
  props: ["course", "changeTCourseUsedNo", "changeCourseOwnerNo"],
  components: {
    confirmationModal,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        courseName: null,
        courseCode: null,
        continualEducationUnit: null,
        courseDuration: null,
        courseLevelId: null,
        courseOwnerId: null,
        courseAccreditorId: null,
        courseAccreditationDate: null,
        targetAudienceIds: [],
        passingScore: null,
        courseLevels: [],
        isAccredited: false,
        editMode: false,
      },
      courseLevels: [],
      courseLevelDraft: {
        courseLevelId: null,
        continualEducationUnit: null,
        courseDuration: null,
        passingScore: null,
      },
      courseLevelError: "",
      showProgress: false,
      COURSE_LEVELS: [],
      COURSE_OWNER: [],
      ACCREDITED_BY: [],
      TARGET_AUDIENCE: [],
      TRAINING_COURSE_USED: [],
      showAccreditationOptions: false,
      showOwnerName: false,
      startMenu: false,
      mutableTCourseUsedNo: this.changeTCourseUsedNo,
      mutableCourseOwnerNo: this.changeCourseOwnerNo,
      showTrainingCourseUsed: false,
      date: new Date().toISOString().substr(0, 10),
      etDate: null,
      clearable: true,
      searchable: true,
      courseLevelLoading: false,
      courseOwnerLoading: false,
      accreditorsLoading: false,
      targeAudLoading: false,
      courseContentFile: null,
      courseContentPreviewUrl: null,
      courseContentExistingUrl: null,
      courseContentObjectUrl: null,

      confirmation: false,
      title:''
    };
  },
  beforeMount() {
    const user = getUser();
    const date = new Date().toISOString().substr(0, 10);
    this.etDate = this.convertGE(date);
    this.formValues.courseAccreditorId = this.formValues.courseAccreditorId ?? user.data.accreditorId;
  },
  async created() {
    const user = getUser();
    const date = new Date().toISOString().substr(0, 10);
    this.etDate = this.convertGE(date);

    if (this.course != null) {
      this.formValues = this.course;
      this.loadCourseLevelsFromCourse(this.course);
      let targetAudienceIds = [];
      this.course.courses_target_audiences.forEach((targetAudience) => {
        targetAudienceIds.push(targetAudience.targetAudienceId);
      });
      this.formValues.targetAudienceIds = targetAudienceIds;
      if (this.formValues.isAccrediting) {
        this.formValues.courseAccreditorId = user.data.accreditorId || null;
        this.formValues.courseAccreditationDate = this.date;
      }
      this.formValues.editMode = true;
      await this.prefetchCourseContentPreview();
    }
    await this.initateLookups();
    if (this.formValues.isAccrediting) {
      this.formValues.courseAccreditor = this.ACCREDITED_BY.find(
          (accreditor) => Number(accreditor.id) === Number(this.formValues.courseAccreditorId)
      );
      this.generateCourseCode();
    }

  },
  beforeDestroy() {
    if (this.courseContentObjectUrl) {
      URL.revokeObjectURL(this.courseContentObjectUrl);
      this.courseContentObjectUrl = null;
    }
  },
  computed: {
    canChooseAccreditor() {
      return canChooseCourseAccreditor(getUser());
    },
  },
  methods: {
    updateAccreditorForCourseCode() {
      this.formValues.courseAccreditor = this.ACCREDITED_BY.find(
          (accreditor) => Number(accreditor.id) === Number(this.formValues.courseAccreditorId)
      );
      if (this.formValues.courseAccreditorId) this.generateCourseCode();
    },
    async showConfirmation(editMode, isAcc) {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      if (isAcc && !canAccreditCourses(getUser())) {
        this.$toast.error("Only an accreditor or MOH user can accredit courses.");
        return;
      }
      if (!this.courseLevels.length) {
        this.courseLevelError = "Add at least one course level.";
        return;
      }
      this.courseLevelError = "";

      this.confirmation = true;
      this.title = editMode? (isAcc ? "Accredit Course" : "Update Course")  : "Add Course"
    },
    getCourseContentPath() {
      return (
          this.formValues?.courseContent ||
          this.formValues?.course_content ||
          this.formValues?.courseContentUrl ||
          this.formValues?.course_content_url ||
          null
      );
    },
    async prefetchCourseContentPreview() {
      const path = this.getCourseContentPath();
      if (!path) return;
      const url = await buildPreviewUrl(path, {
        preferHttps: window.location.protocol === "https:",
        allowInsecure: true,
        toast: this.$toast,
      });
      if (url) {
        this.courseContentExistingUrl = url;
        if (!this.courseContentFile) {
          this.courseContentPreviewUrl = url;
        }
      }
    },
    handleCourseContentChange(file) {
      const nextFile = Array.isArray(file) ? file[0] : file;
      if (this.courseContentObjectUrl) {
        URL.revokeObjectURL(this.courseContentObjectUrl);
        this.courseContentObjectUrl = null;
      }
      if (nextFile) {
        this.courseContentObjectUrl = URL.createObjectURL(nextFile);
        this.courseContentPreviewUrl = this.courseContentObjectUrl;
      } else {
        this.courseContentPreviewUrl = this.courseContentExistingUrl;
      }
    },
    async openCourseContent() {
      if (this.courseContentObjectUrl) {
        window.open(this.courseContentObjectUrl, "_blank");
        return;
      }
      const path = this.getCourseContentPath();
      if (path) {
        await openPresignedUrl(path, {
          preferHttps: window.location.protocol === "https:",
          allowInsecure: true,
          toast: this.$toast
        });
      }
    },
    hasInlineCourseContentPreview() {
      const fileName = this.getCurrentCourseContentName().toLowerCase();
      return fileName.endsWith(".pdf");
    },
    getCurrentCourseContentName() {
      if (this.courseContentFile?.name) {
        return this.courseContentFile.name;
      }
      const path = this.getCourseContentPath();
      if (!path || typeof path !== "string") return "Uploaded document";
      const cleanPath = path.split("?")[0];
      return cleanPath.split("/").pop() || "Uploaded document";
    },
    addCourseLevel() {
      this.courseLevelError = "";
      const levelId = Number(this.courseLevelDraft.courseLevelId);
      const ceuInput = this.courseLevelDraft.continualEducationUnit;
      const durationInput = this.courseLevelDraft.courseDuration;
      const passingInput = this.courseLevelDraft.passingScore;
      const ceu = Number(ceuInput);
      const duration = Number(durationInput);
      const passing = Number(passingInput);

      if (!Number.isFinite(levelId)) {
        this.courseLevelError = "Select a course level.";
        return;
      }
      if (this.courseLevels.some((level) => Number(level.courseLevelId) === levelId)) {
        this.courseLevelError = "This course level is already added.";
        return;
      }
      if (ceuInput === null || ceuInput === "" || !Number.isFinite(ceu) || ceu < 0 || ceu > 15) {
        this.courseLevelError = "CEU must be between 0 and 15.";
        return;
      }
      if (durationInput === null || durationInput === "" || !Number.isFinite(duration) || duration <= 0) {
        this.courseLevelError = "Course duration must be greater than 0.";
        return;
      }
      if (passingInput === null || passingInput === "" || !Number.isFinite(passing) || passing < 0 || passing > 100) {
        this.courseLevelError = "Passing score must be between 0 and 100.";
        return;
      }

      this.courseLevels.push({
        courseLevelId: levelId,
        continualEducationUnit: ceu,
        courseDuration: duration,
        passingScore: passing,
      });

      this.courseLevelDraft = {
        courseLevelId: null,
        continualEducationUnit: null,
        courseDuration: null,
        passingScore: null,
      };
    },
    removeCourseLevel(index) {
      this.courseLevels.splice(index, 1);
    },
    getCourseLevelName(courseLevelId, courseLevel) {
      if (courseLevel?.name) return courseLevel.name;
      const match = this.COURSE_LEVELS.find((level) => level.id === courseLevelId);
      return match ? match.name : courseLevelId ? String(courseLevelId) : "-";
    },
    loadCourseLevelsFromCourse(course) {
      const levels =
          course?.courseLevels ||
          course?.course_levels ||
          course?.courseLevelDetails ||
          course?.course_level_details;
      if (Array.isArray(levels) && levels.length) {
        const seen = new Set();
        this.courseLevels = levels
            .map((level) => {
              const courseLevel = level.courseLevel || level.course_level;
              return {
                courseLevelId: level.courseLevelId || level.course_level_id || courseLevel?.id,
                continualEducationUnit: level.continualEducationUnit ?? level.continual_education_unit,
                courseDuration: level.courseDuration ?? level.course_duration,
                passingScore: level.passingScore ?? level.passing_score,
                courseLevel,
              };
            })
            .filter((level) => {
              if (!level.courseLevelId) return false;
              if (seen.has(level.courseLevelId)) return false;
              seen.add(level.courseLevelId);
              return true;
            });
        return;
      }

      const fallbackLevelId = course?.courseLevelId || course?.courseLevel?.id;
      if (fallbackLevelId || course?.continualEducationUnit || course?.courseDuration || course?.passingScore) {
        this.courseLevels = [
          {
            courseLevelId: fallbackLevelId,
            continualEducationUnit: course?.continualEducationUnit ?? null,
            courseDuration: course?.courseDuration ?? null,
            passingScore: course?.passingScore ?? null,
            courseLevel: course?.courseLevel,
          },
        ].filter((level) => level.courseLevelId);
      }
    },
    syncCourseLevels() {
      const normalized = this.courseLevels.map((level) => {
        const payload = {
          courseLevelId: level.courseLevelId,
          continualEducationUnit: level.continualEducationUnit,
          courseDuration: level.courseDuration,
          passingScore: level.passingScore,
        };
        if (this.formValues.id) {
          payload.courseId = this.formValues.id;
        }
        return payload;
      });
      this.formValues.courseLevels = normalized;
      if (normalized.length) {
        const primary = normalized[0];
        this.formValues.courseLevelId = primary.courseLevelId;
        this.formValues.continualEducationUnit = primary.continualEducationUnit;
        this.formValues.courseDuration = primary.courseDuration;
        this.formValues.passingScore = primary.passingScore;
      }
    },
    generateCourseCode() {
      const courseLevelName = this.getCourseLevelNameForCode();
      const courseLevel = courseLevelName ? courseLevelName.substring(0, 1) : "";
      const accreditor = this.formValues.courseAccreditor ? this.formValues.courseAccreditor.accreditorName ? this.formValues.courseAccreditor.accreditorName.substring(0, 1) : this.formValues.courseAccreditor.name ? this.formValues.courseAccreditor.name.substring(0, 1) : this.formValues.courseAccreditor.substring(0, 1) : null;
      const accreditationDate = this.formValues.courseAccreditationDate;
      const accreditationString = accreditationDate.toString().split('-');
      const microsecond = new Date().getMilliseconds();
      const year = accreditationString[0];
      const month = accreditationString[1];
      const serial = this.generateFourDigitSerial(this.formValues.courseAccreditorId ? this.formValues.courseAccreditorId : 1);
      const generatedCode = courseLevel + accreditor + year + month + microsecond + serial;
      // const generatedCode = year + month + microsecond + serial;
      this.formValues.courseCode = generatedCode;
      return generatedCode;
    },
    getCourseLevelNameForCode() {
      if (this.formValues.courseLevel?.name) {
        return this.formValues.courseLevel.name;
      }
      const primaryLevel = this.courseLevels[0];
      if (primaryLevel?.courseLevel?.name) {
        return primaryLevel.courseLevel.name;
      }
      if (primaryLevel?.courseLevelId) {
        return this.getCourseLevelName(primaryLevel.courseLevelId);
      }
      if (this.formValues.courseLevelId) {
        return this.getCourseLevelName(this.formValues.courseLevelId);
      }
      return "";
    },

    generateFourDigitSerial(number) {
      const newNumber = number + 1;
      const numberString = newNumber.toString();

      if (numberString.length === 4) {
        return numberString;
      }

      const leadingZeros = '0'.repeat(4 - numberString.length);
      return leadingZeros + numberString;
    },

    async initateLookups() {
      this.courseLevelLoading = true;
      this.courseOwnerLoading = true;
      this.accreditorsLoading = true;
      this.targeAudLoading = true;
      this.COURSE_LEVELS = await getCourseLevel();
      this.courseLevelLoading = false;
      const accreditorsResp = await AccreditorService.getAllAccreditorsList();
      this.ACCREDITED_BY = accreditorsResp.data.rows.filter((data) => {
        return data.isActive == true;
      });
      this.accreditorsLoading = false;
      const cpdResponse = await TrainingCenterService.getAllTrainingCenters();

      const user = getUser();
      if(!this.formValues.courseOwnerId && user?.data?.cpdProviderId){
        this.COURSE_OWNER = cpdResponse.data.rows.filter((data) => {
          return (data.id == user?.data?.cpdProviderId || data.id == 36) && data.isActive == true;
        });
      }
      else{
        this.COURSE_OWNER = cpdResponse.data.rows.filter((data) => {
          return data.isActive == true;
        });
      }
      this.courseOwnerLoading = false;
      const tAudienceResp = await getHealthProfessions();
      this.TARGET_AUDIENCE = tAudienceResp.rows.filter((data) => {
        return data.isActive == true;
      });
      this.targeAudLoading = false;
    },
    convertGE(val) {
      if (!val) return val;
      const [year, month, day] = val.split("-").map(Number);
      if (this.pickerType === "year") {
        let etDate = ethiopic.ge(year, month || 6, day || 1); // so it will be the same year in both directions
        return etDate.year.toString().padStart(4, "0");
      } else {
        let etDate = ethiopic.ge(year, month || 1, day || 1);
        return (
            etDate.year.toString().padStart(4, "0") +
            "-" +
            etDate.month.toString().padStart(2, "0") +
            "-" +
            etDate.day.toString().padStart(2, "0")
        );
      }
    },
    convertEG(val) {
      if (!val) return val;
      const [etYear, etMonth, etDay] = val.split("-").map(Number);
      if (this.pickerType === "year") {
        let gDate = ethiopic.eg(etYear, etMonth || 6, etDay || 1); // so it will be the same year in both directions
        return gDate.year.toString().padStart(4, "0");
      } else {
        let gDate = ethiopic.eg(etYear, etMonth || 1, etDay || 1);
        return (
            gDate.year.toString().padStart(4, "0") +
            "-" +
            gDate.month.toString().padStart(2, "0") +
            "-" +
            gDate.day.toString().padStart(2, "0")
        );
      }
    },
    async submit() {
      this.confirmation = false;
      if (!this.courseLevels.length) {
        this.courseLevelError = "Add at least one course level.";
        return;
      }
      this.syncCourseLevels();
      if (this.formValues.isAccrediting) this.formValues.isAccredited = true;
      const payload = {
        ...this.formValues,
        courseContentFile: this.courseContentFile,
      };
      this.$emit("registerOrUpdateCourse", payload);
    },
  },
};
</script>

<style scoped>
.course-form__shell {
  padding: 12px;
}

.course-form__grid {
  margin: 12px 16px 6px;
  row-gap: 12px;
}

.course-form__grid > div {
  margin-bottom: 0 !important;
}

.course-form__grid br {
  display: none;
}

.course-form__actions {
  margin: 8px 16px 16px;
  justify-content: flex-end;
}

.course-form__actions .w-full {
  display: flex;
  justify-content: flex-end;
}

.course-form__submit {
  background: #1976d2;
  border: 1px solid #1976d2;
  color: #ffffff;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 6px;
}

.course-form__submit:hover {
  background: #1565c0;
  border-color: #1565c0;
}

.course-content__preview {
  margin-top: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px;
  background: #f8fafc;
}

.course-content__actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 6px;
}

.course-content__frame {
  width: 100%;
  min-height: 240px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #ffffff;
}

.course-content__file {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 72px;
  padding: 12px;
  border: 1px dashed #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  color: #0f172a;
}

.course-content__file-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.course-content__file-note {
  font-size: 12px;
  color: #64748b;
}

.course-levels__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.course-levels__count {
  background: #e2e8f0;
  color: #334155;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 700;
}

.course-levels__editor {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 12px;
}

.course-levels__action {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.course-levels__add {
  text-transform: none;
  font-weight: 600;
}

.course-levels__error {
  margin-top: 6px;
  font-size: 12px;
  color: #b91c1c;
}

.course-levels__table {
  overflow-x: auto;
}

.course-levels__table table {
  width: 100%;
  table-layout: auto;
  min-width: 820px;
}

.course-levels__table th {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
  font-weight: 600;
  background: #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
}

.course-levels__table td {
  vertical-align: middle;
}

.course-levels__table th:nth-child(1),
.course-levels__table td:nth-child(1) {
  min-width: 220px;
}

.course-levels__table th:nth-child(2),
.course-levels__table td:nth-child(2),
.course-levels__table th:nth-child(3),
.course-levels__table td:nth-child(3),
.course-levels__table th:nth-child(4),
.course-levels__table td:nth-child(4) {
  min-width: 150px;
}

.course-levels__table th:nth-child(5),
.course-levels__table td:nth-child(5) {
  min-width: 140px;
}

.course-levels__draft td {
  background: #f8fafc;
}

.course-levels__input {
  margin: 0;
  width: 100%;
}

.course-levels__remove {
  text-align: right;
}

.course-levels__empty {
  padding: 12px 8px;
  font-size: 12px;
  color: #64748b;
}

@media (max-width: 700px) {
  .course-levels__editor {
    padding: 8px;
  }
}

.course-levels.required .course-levels__header label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}

.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
